"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.prompt.title': 'Attiva/Disattiva Prompt Avanzati',
    'shortcuts.prompt.description': 'Abilita o disabilita la struttura avanzata dei prompt e il sistema di slot',
};
